module.exports = __webpack_public_path__ + "static/media/gallery11.335d0c40.jpg";